import assign from "lodash/assign";
import startOfDay from "date-fns/startOfDay";
import endOfDay from "date-fns/endOfDay";
import { normalizeDate } from "../../../helpers/date";
var TimeSlotModel = /** @class */ (function () {
    function TimeSlotModel(props) {
        assign(this, props);
    }
    Object.defineProperty(TimeSlotModel.prototype, "milliseconds", {
        get: function () {
            return new Date(this.fromDate).getTime();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TimeSlotModel.prototype, "startOfDay", {
        get: function () {
            return startOfDay(this.fromDate).getTime();
        },
        enumerable: false,
        configurable: true
    });
    TimeSlotModel.prototype.setIsAvailable = function (isAvailable) {
        this.is_available = isAvailable;
    };
    TimeSlotModel.prototype.isOnDate = function (dirtyReferenceDate) {
        var date = normalizeDate(dirtyReferenceDate);
        return startOfDay(date) < this.fromDate && endOfDay(date) > this.fromDate;
    };
    return TimeSlotModel;
}());
export { TimeSlotModel };
